module.exports = __webpack_public_path__ + "img/copy-field.b8ab8043.svg";